module.exports = __webpack_public_path__ + "static/9y-logo-black-blue-156812a710691fb1fec08e48b7192f9e.png";